/**
 * View split left and right parts, default 50% 50% relation
 *
 */
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";
const usePageContainerStyles = makeThemedStyles("PageContainer", (theme) => ({
  root: {
    minWidth: "1250px",
    marginLeft: "20px",
    marginRight: "20px",
    paddingTop: "10px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
}));
const PageContainer = (
  props: React.PropsWithChildren<{ width?: string; className?: string }>
) => {
  const styles = usePageContainerStyles();
  return (
    <div
      className={`${styles.root} ${props.className}`}
      style={{
        width: props.width,
        marginLeft: props.width ? "auto" : undefined,
        marginRight: props.width ? "auto" : undefined,
      }}
    >
      {props.children}
    </div>
  );
};

export default PageContainer;
